// extracted by mini-css-extract-plugin
module.exports = {"status_modal":"StatusPopupComponent_status_modal__U2Ztg","error":"StatusPopupComponent_error__fApnj","message_text":"StatusPopupComponent_message_text__3wZ2c"};